import React from "react";
import { Button } from "react-bootstrap";

// Vote on a proposal
// Lockbox instance (this.state.lockbox) is passed into to props as props.lockbox
// Address of sender (this.state.address) is passed into props as props.address
function VoteTab(props) {

    const handleVote = (event) => {
        event.preventDefault();
        submitVote(event.target.proposalID.value);
    }

    const submitVote = async (proposalID) => {
        const currProposals = await props.lockbox.methods.viewActiveProposals().call();

        // iterate through active proposals, validate proposalID matches an active one
        let temp = false;
        for (let i = 0; i < currProposals.length; i++) {
            if (currProposals[i][0] == proposalID) {
                temp = true;
                break;
            }
        }

        if (!temp) {
            alert("This proposalID doesn't match an existing active proposal.");
            return;
        }

        // ensure this lockbox has sufficient funds
        let catBalance = await props.lockbox.methods.getProposalCategoryBalance(proposalID).call();
        let proposalAmnt = await props.lockbox.methods.getProposalValue(proposalID).call();

        catBalance = parseInt(catBalance);
        proposalAmnt = parseInt(proposalAmnt);

        if (catBalance < proposalAmnt) {
            alert("Cannot vote. Not enough resources in the category of proposal " + proposalID + " to approve the proposal");
        } else {
            await props.lockbox.methods.proposalVote(proposalID).send({ from: props.address });
        }
    }

    return (
        <form onSubmit={handleVote}>
            <label>Which Proposal ID would you like to vote for?</label>
            <br />
            <input type="number" step="1" min="1" name="proposalID" className="form-control w-25 center-block"></input>
            <br />
            <br />
            <Button variant="dark" type="submit">Submit Vote</Button>
        </form>
    )
}

export default VoteTab